export const tabsKeywordStyle = theme => ({
    marginTab: {
        paddingTop: theme.spacing(2)
    },
    contentTab: {
        padding: theme.spacing(2),
        border: '1px solid rgba(0, 0, 0, 0.12)',
        whiteSpace: 'normal',
        minHeight: '300px'
    },
    contentExpand: {
        whiteSpace: 'normal'
    },
    contentCount: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    tab: {
        minWidth:'100px'
    }
})